import { FeeModel } from './fee.model';

export class PaymentModel {
  public paymentRefNo: number;
  public nic: string;
  public name: string;
  public applicationType: string;
  public createdTime: string;
  public cdcNo: string;
  public status: string;
  public appRefNo: number;
  public feeList: FeeModel[];

  public onlinePaymentRefUuid: string;
  public onlinePaymentResponseId: string;
  public onlineInvoiceNo: string;
  public onlineInvoiceDate: Date;
  public receiptDate: Date;
  public amount: number;
  public convinceAmount: number;
  public convincePercentage: number;
  public stampdutyPercentage: number;
  public stampdutyAmount: number;
  public vatPercentage: number;
  public vatAmount: number;
  public usdToLkr: number;
  public totalAmount: number;
  public idCardType: string;
  public paymentCategory: string;
  public paymentStatus: string;
  public lastUpdatedTime: Date;
  public lastUpdatedUser: string;
}
